// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_hc-0";